import { EVENT_FEATURE, type AnalyticsEventName } from '@beacon/analytics-events';
import { posthog } from '@/lib/posthog';

/**
 * Capture a product event in PostHog
 */
export function track(event: AnalyticsEventName, properties?: Record<string, unknown>) {
  posthog.capture(event, { feature: EVENT_FEATURE[event], ...properties });
}
